import type { Plugin } from './plugin'

export class Selectors {
  // NOTE: intentionally not typed here so that type can be inferred
  public readonly inProgress

  constructor(plugin: Plugin) {
    this.inProgress = plugin.feature.state.project(state => state.inProgress)
  }
}
